module.exports = __webpack_public_path__ + "static/media/ytpoet.ade3d9fb.png";